import T from 'prop-types'
/*
PW FilterableList

-filterval [string]: String that will be compared against the filterProp value of each child component to determine if it should be rendered
-filterProp [string, default "key"]: prop on each child that will be used for filter comparison
*/

import React from 'react'
import cx from 'classnames'

const SPAN_ALL_THE_THINGS = 42

class FilterableList extends React.Component {
  static displayName = 'FilterableList'

  static propTypes = {
    filterVal: T.string,
    filterProp: T.string,
    tableMode: T.bool,
    tagName: T.string,
    emptyText: T.string
  }

  static defaultProps = {
    filterVal: '',
    filterProp: 'key',
    tableMode: false,
    tagName: 'div',
    emptyText: 'No Results'
  }

  _renderNoResults = count => {
    if (count !== 0) {
      return null
    }
    return this.props.tableMode
      ? <tr className="no_items_row">
          <td colSpan={SPAN_ALL_THE_THINGS}>
            <div className="no_items">No Results</div>
          </td>
        </tr>
      : <div className="no_items">
          {this.props.emptyText}
        </div>
  }

  _renderCounts = (count, total) => {
    if (count === total) {
      return null
    }
    return this.props.tableMode
      ? <tr className="result_count">
          <td colSpan={SPAN_ALL_THE_THINGS}>
            <span className="ct">{count}</span> matches of{' '}
            <span className="ct">{total}</span> results
          </td>
        </tr>
      : <div className="result_count">
          <span className="ct">{count}</span> matches of{' '}
          <span className="ct">{total}</span> results
        </div>
  }

  render() {
    const props = this.props
    let count = 0
    const children = React.Children.map(props.children, childMenuItem => {
      const childPropVal = childMenuItem.props[props.filterProp]
      if (
        !props.filterVal ||
        (childPropVal &&
          childPropVal
            .toString()
            .toLowerCase()
            .indexOf(props.filterVal.toLowerCase()) >= 0)
      ) {
        count++
        return childMenuItem
      } else {
        return null
      }
    })

    return React.createElement(
      props.tagName,
      { className: cx('filterable_list', props.className) },
      this._renderCounts(count, props.children.length),
      children,
      this._renderNoResults(count)
    )
  }
}

export default FilterableList
